<template>
<div>
    <ks-data-provider
        :id="`input_search_selector_provider_${_uid}`"
        :dataSource="searchDataprovider.dataSource"
        :defaultFilters="searchDataprovider.defaultFilters||{}"
        :defaultOrderBy="searchDataprovider.defaultOrderBy||null"
        :defaultPageSize="searchDataprovider.defaultPageSize||30"
        :enableUrlModes="false"
        :enableLoadListOnMount="false"
        :enableLoadRecordOnMount="false"
        @onError="error"
        @onLoad="ready = true"
    />
    <template v-if="ready">
        <input
            v-if="!hasDefaultSlot"
            :id="'ks-input-search-selector-input'+_uid"
            type="text"
            :placeholder="placeholder"
            class="form-control"
            @focus="showOptions"
            @blur="hideOptions"
            @input="inputSearchEvent($event.target.value)"
            @keypress.enter.prevent=""
            autocomplete="new-password">
        <slot></slot>
        <div
            v-show="enableOptions&&isValidTerm"
            :style="contentStyle"
            class="input-search-selector-content"
        >
            <ks-scroll-list 
                :dataProvider="`input_search_selector_provider_${_uid}`" 
                :reverse="false" 
                type="custom"
                :height="`calc(${height} - 20px)`" 
                :ref="`input-search-selector-scroll-list-${_uid}`"
                :loadDelay="loadDelay"
                @onRowClick="onRowClick"
            >
                <template #item="{row,index}">
                    <slot 
                        name="item" 
                        :row="row" 
                        :index="index" 
                    />
                </template>
                <template #noRecords>
                    <slot name="noRecords"></slot>
                </template>
            </ks-scroll-list>
        </div>
    </template>
</div>
</template>

<script>
export default {
    name: 'input-search-selector',
    props: {
        searchDataprovider:{
            type: Object,
            required:true
        },
        placeholder: {
            type: String,
            default: ''
        },
        width: {
            type: String,
            default: '250px'
        },
        height: {
            type: String,
            default: 'calc(100vh - 600px)'
        },
        top:{
            type: String,
            default: '0px' 
        },
        left: {
            type: String,
            default: '0px'
        },
        right: {
            type: String,
            default: '0px'
        },
        customContentStyle:{
            default: null
        },
        minSearchLength:{
            type: Number,
            default: 0
        },
        loadDelay:{
            type: Number,
            default: 0
        }  
    },
    computed:{
        hasDefaultSlot () {
            return !!this.$slots.default;
        },
        contentStyle() {
            if(this.customContentStyle !== null){
                return this.customContentStyle;
            }else{
                return {'width': this.width, 'height': this.height, 'top': this.top, 'left': this.left, 'right': this.right }
            }
        },
        isValidTerm() {
            return this.searchTermLength >= this.minSearchLength ? true : false;
        },
        data_provider_ref() {
            return this.$parent.data_provider_ref ? this.$parent.data_provider_ref : {};
        },
        dataProvider() {
            return this.$parent.dataProvider ? this.$parent.dataProvider : null;
        },
        type() {
            return this.$parent.type ? this.$parent.type : null;
        }
    },
    methods:{
        error(err){
           console.log(err);
        },
        showOptions() {
            this.enableOptions = true;
        },
        hideOptions() {
            setTimeout(() => {
                this.$emit('blur', this);
                this.enableOptions = false;
            }, 200);
        },
        inputSearchEvent(value) {
            this.searchTermLength = value ? value.length : 0;

            if (this.timeout || value.length < this.minSearchLength) {
                clearTimeout(this.timeout);
            }
            if (value.length >= this.minSearchLength) {
                this.timeout = setTimeout(() => {
                    this.$refs[`input-search-selector-scroll-list-${this._uid}`].loading = true;
                    let dataproviderRef = app.getDataprovider(`input_search_selector_provider_${this._uid}`);
                    dataproviderRef.updateFilters({'search_string': value}, true);
                    this.$refs[`input-search-selector-scroll-list-${this._uid}`].reloadList();
                }, 1200);
            }
        },
        onRowClick(evt){
            this.$emit('onRowClick', evt);
        }
    },
    data(){
        return {
            enableOptions: false,
            timeout: null,
            ready: false,
            searchTermLength: 0
        }
    }

}
</script>

<style>
.input-search-selector-content {
  position: absolute;
  top: 0px;
  left: 0px;
  z-index: 10000;
  background: white;
  border: 1px solid black;
  border-radius: 4px;
  padding: 10px;
  box-shadow: rgb(136, 136, 136) 5px 8px 7px;
  margin-top: 45px;
  overflow: hidden;
  font-size: 16px;
}

</style>